import { AbstractControl, ValidatorFn } from '@angular/forms';

export const phoneValidator = (isOptional: boolean = false, mobileOnly: boolean = false): ValidatorFn => {
  return (control: AbstractControl) => {
    const phone: string = control.value;
    const validNumber = /^(?:\+?61|0)(?:\s*[0-9]){9}$/;
    if (phone !== null) {
      if ((!isOptional || (isOptional && phone.length > 0)) && mobileOnly) {
        return phone && phone.toString().substr(0,2) === '04'
          ? null
          : { phone: true };
      }

      if (!isOptional || (isOptional && phone.length > 0)) {
        return phone && validNumber.test(phone)
          ? null
          : { phone: true };
      }
    }
    return null;
  };
};



// WEBPACK FOOTER //
// ./src/app/shared/validators/phone.validator.ts